import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'material-ui/FontIcon';
import CloseCodeRadioGroup from 'closeCodeComponents/CloseCodeRadioGroup';
import RaisedButton from 'material-ui/RaisedButton';
import { List } from 'material-ui/List';
import CustomStep from 'workOrderComponents/close/CustomStep';

class CloseCodeCloseStep extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {
            workOrderActions,
            orderCloseDetails,
            orderId,
            billingSystem,
            closeCodes,
            user,
            stepConfig,
            disabled
        } = this.props;

        const stepValidation = orderCloseDetails.getIn(['stepValidation']);
        const activeStep = orderCloseDetails.get('currentStep');

        const refreshIcon = (
            <FontIcon className="material-icons">refresh</FontIcon>
        );

        const refreshButton = (
            <RaisedButton
                label="Close Codes"
                primary={true}
                disabled={disabled}
                icon={refreshIcon}
                onTouchTap={() => workOrderActions.clearWorkOrderDetail(orderId, 'closeCodes')} />
        );

        let sections = null;
        const codeDisplayList = [];


        if (closeCodes && closeCodes.count() > 0) {
            const selectedCloseCodeList = orderCloseDetails.getIn(['closeOrderRequest', 'closeCode']);
            const rows = closeCodes.map((code, codeIndex) => {
                let checked = false;

                if (selectedCloseCodeList) {
                    const selectedCode = selectedCloseCodeList
                        .find((existingCode) => {
                            return existingCode.get('code') === code.get('code');
                        });

                    if (selectedCode) {
                        codeDisplayList.push(code.get('description'));
                        checked = true;
                    }
                }

                return (<CloseCodeRadioGroup
                    user={user}
                    disabled={disabled}
                    workOrderActions={workOrderActions}
                    key={`close_code_menu_item_${codeIndex}`}
                    closeCode={code}
                    orderId={orderId}
                    checked={checked}
                    billingSystem={billingSystem}
                    selectedCloseCodeList={selectedCloseCodeList}
                />);
            });

            sections = (
                <div>
                    <p>Select 1 resolution below</p>
                    <List>
                        {rows}
                    </List>
                </div>
            );
        }

        let codeDisplay = codeDisplayList.join(', ');

        if (codeDisplayList.length > 2) {
            codeDisplay = codeDisplayList.length;
        }

        if (codeDisplayList.length > 0) {
            codeDisplay = ` - ${codeDisplay}`;
        }

        return (

            <CustomStep
                onStepClick={workOrderActions.setCloseStep}
                label={`Close Codes${codeDisplay}`}
                stepConfig={stepConfig}
                stepConfigKey="closeCodeStepConfig"
                orderCloseDetails={orderCloseDetails}
                activeStep={activeStep}
                orderId={orderId}
                stepValidation={stepValidation}
                stepKey="closeCodes">
                <div>
                    {refreshButton}
                    {sections}
                </div>
            </CustomStep>

        );

    }
}

CloseCodeCloseStep.propTypes = {
    workOrderActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    orderId: PropTypes.string,
    billingSystem: PropTypes.string,
    closeCodes: PropTypes.object,
    user: PropTypes.object,
    stepConfig: PropTypes.object,
    disabled: PropTypes.bool
};

export default CloseCodeCloseStep;


// WEBPACK FOOTER //
// ./src/components/close-code/CloseCodeCloseStep.js